const cardVariants = {
    card: {
        bg: 'white',
        boxShadow: 'main',
        userSelect: 'none',
    },
};

export default cardVariants;
